<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>

<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48">
    <path
        d="M512 51.2c-122.88 0-240.64 48.64-327.68 135.68C97.28 273.92 51.2 389.12 51.2 512c0 253.44 207.36 460.8 460.8 460.8s460.8-207.36 460.8-460.8c2.56-253.44-204.8-460.8-460.8-460.8z m391.68 460.8c0 215.04-176.64 391.68-391.68 391.68h-2.56c-104.96 0-202.24-40.96-276.48-115.2C158.72 714.24 120.32 614.4 120.32 512c0-215.04 176.64-391.68 391.68-391.68h2.56c104.96 0 202.24 40.96 276.48 115.2 74.24 74.24 112.64 174.08 112.64 276.48z"
    ></path>
    <path
        d="M729.6 504.32c-2.56 0-2.56 0 0 0-15.36 0-23.04 2.56-25.6 23.04-2.56 38.4-15.36 71.68-38.4 99.84-53.76 66.56-120.32 92.16-199.68 71.68-81.92-20.48-130.56-71.68-145.92-158.72-5.12-30.72-7.68-33.28-40.96-33.28h-2.56c-10.24-2.56-17.92 0-23.04 2.56-7.68 7.68-7.68 17.92-5.12 28.16 12.8 133.12 128 238.08 261.12 238.08 128 0 240.64-94.72 258.56-220.16 2.56-23.04 5.12-33.28 0-40.96-5.12-7.68-15.36-7.68-38.4-10.24zM368.64 432.64c35.84 0 64-28.16 64-61.44 0-33.28-28.16-64-61.44-64-33.28 0-64 25.6-64 61.44 0 17.92 5.12 33.28 17.92 46.08 10.24 10.24 28.16 17.92 43.52 17.92zM652.8 432.64c17.92 0 33.28-5.12 46.08-17.92 12.8-12.8 17.92-28.16 17.92-46.08 0-33.28-28.16-64-61.44-64-33.28 0-61.44 28.16-64 61.44 0 35.84 25.6 66.56 61.44 66.56z"
    ></path>
  </svg>
</template>

<style scoped>

</style>